import React from "react";
import styled from "@emotion/styled";

import { Typography } from "@mui/material";

import { SidebarItemsType } from "../../types/sidebar";
import SidebarNavList from "./SidebarNavList";
import { useTranslation } from "react-i18next";

const Title = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  padding: ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(7)} ${(props) => props.theme.spacing(1)};
  opacity: 0.4;
  text-transform: uppercase;
  display: block;
`;

type SidebarNavSectionProps = {
  className?: Element;
  component?: React.ElementType;
  pages: SidebarItemsType[];
  title?: string;
  isDrawerOpen: boolean;
};

const SidebarNavSection: React.FC<SidebarNavSectionProps> = (props) => {
  const { t } = useTranslation();
  const {
    title,
    pages,
    className,
    component: Component = "nav",
    isDrawerOpen,
    ...rest
  } = props;

  return (
    <Component {...rest}>
      {/* {title && (
        <Title
          variant="subtitle2"
          sx={{ visibility: isDrawerOpen ? "visible" : "hidden" }}
        >
          {t(title)}
        </Title>
      )} */}
      <SidebarNavList pages={pages} depth={0} isDrawerOpen={isDrawerOpen} />
    </Component>
  );
};

export default SidebarNavSection;
